/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState, state, forwardRef, useImperativeHandle } from "react";
import toast from "react-hot-toast";

import Button from "@mui/material/Button";

const AntecedentesPatologicos = forwardRef(
  ({ Back, Next, props, vista = "registrar", desactivar }, ref) => {
    const [DietaAlimentacion, setDietaAlimentacion] = useState(
      props?.dietaAlimentacion ? props.dietaAlimentacion : ""
    );
    const [VacunacionCompleta, setVacunacionCompleta] = useState(props?.vacunacionCompleta ?? null);
    const [FumanEnCasa, setFumanEnCasa] = useState(props?.fumanEnCasa ?? null);

    const [QuienFuma, setQuienFuma] = useState(props?.quienFuma ? props.quienFuma : "");
    const [IdTipoSangre, setIdTipoSangre] = useState(props?.idTipoSangre ?? null);
    const [IdTipoSangreRh, setIdTipoSangreRh] = useState(props?.idTipoSangreRh ?? null);
    const [AsisteGuarderia, setAsisteGuarderia] = useState(props?.asisteGuarderia ?? null);
    const [AlergiasCandidato, setAlergiasCandidato] = useState(
      props?.alergiasCandidato ? props.alergiasCandidato : ""
    );
    const [isvalid_DietaAlimentacion, isvalid_setDietaAlimentacion] = useState(false);
    const [isvalid_VacunacionCompleta, isvalid_setVacunacionCompleta] = useState(false);
    const [isvalid_FumanEnCasa, isvalid_setFumanEnCasa] = useState(false);
    const [isvalid_QuienFuma, isvalid_setQuienFuma] = useState(false);
    const [isvalid_IdTipoSangre, isvalid_setIdTipoSangre] = useState(false);
    const [isvalid_IdTipoSangreRh, isvalid_setIdTipoSangreRh] = useState(false);
    const [isvalid_AsisteGuarderia, isvalid_setAsisteGuarderia] = useState(false);
    const [isvalid_AlergiasCandidato, isvalid_setAlergiasCandidato] = useState(false);

    const ValidaForm = () => {
      if (!DietaAlimentacion) {
        toast.error("Dieta y Alimentación: Campo obligatorio *");
        isvalid_setDietaAlimentacion(true);
        return null;
      }
      if (VacunacionCompleta === null || VacunacionCompleta === undefined) {
        toast.error("¿Cuenta con el esquema completo de vacunación? Campo obligatorio *");
        isvalid_setVacunacionCompleta(true);
        return null;
      }

      if (FumanEnCasa === null || FumanEnCasa === undefined) {
        toast.error("¿Fuman en Casa?: Campo obligatorio *");
        isvalid_setFumanEnCasa(true);
        return null;
      }

      if (FumanEnCasa == "1" && !QuienFuma) {
        toast.error("¿Quién?: Campo obligatorio *");
        isvalid_setQuienFuma(true);
        return null;
      }

      if (IdTipoSangre === null || IdTipoSangre === undefined) {
        toast.error("Tipo de Sangre: Campo obligatorio *");
        isvalid_setIdTipoSangre(true);
        return null;
      }

      if (IdTipoSangreRh === null || IdTipoSangreRh === undefined) {
        toast.error("Tipo de Sangre RH: Campo obligatorio *");
        isvalid_setIdTipoSangreRh(true);
        return null;
      }

      if (AsisteGuarderia === null || AsisteGuarderia === undefined) {
        toast.error("¿Asiste a guardería?: Campo obligatorio *");
        isvalid_setAsisteGuarderia(true);
        return null;
      }

      if (!AlergiasCandidato) {
        toast.error("Alergias: Campo obligatorio *");
        isvalid_setAlergiasCandidato(true);
        return null;
      }
      const datosFormulario = {
        dietaAlimentacion: DietaAlimentacion, // string
        vacunacionCompleta: VacunacionCompleta, // Autocomplete: { label, value }
        fumanEnCasa: FumanEnCasa, // Autocomplete: { label, value }
        quienFuma: QuienFuma, // string (solo si FumanEnCasa.value == "1")
        idTipoSangre: IdTipoSangre, // Autocomplete: { label, value }
        idTipoSangreRh: IdTipoSangreRh, // Autocomplete: { label, value }
        asisteGuarderia: AsisteGuarderia, // Autocomplete: { label, value }
        alergiasCandidato: AlergiasCandidato, // string
      };

      Next(datosFormulario);
      return datosFormulario;
    };

    //Métodos para guardar los datos editados:
    useImperativeHandle(ref, () => ({
      ejecutarNext: () => {
        return ValidaForm();
      },
    }));

    const handleBack = () => {
      const data = {
        dietaAlimentacion: DietaAlimentacion, // string
        vacunacionCompleta: VacunacionCompleta, // Autocomplete: { label, value }
        fumanEnCasa: FumanEnCasa, // Autocomplete: { label, value }
        quienFuma: QuienFuma, // string (solo si FumanEnCasa.value == "1")
        idTipoSangre: IdTipoSangre, // Autocomplete: { label, value }
        idTipoSangreRh: IdTipoSangreRh, // Autocomplete: { label, value }
        asisteGuarderia: AsisteGuarderia, // Autocomplete: { label, value }
        alergiasCandidato: AlergiasCandidato, // string
      };

      Back(data);
    };

    return (
      <>
        {/* DietaAlimentacion */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Dieta y Alimentación:
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              fullWidth
              variant="outlined"
              label="Describa"
              autoComplete="off"
              disabled={desactivar}
              value={DietaAlimentacion}
              onChange={(e) => setDietaAlimentacion(e.target.value)}
              error={isvalid_DietaAlimentacion}
              helperText={isvalid_DietaAlimentacion ? "Campo obligatorio *" : ""}
              onFocus={() => isvalid_setDietaAlimentacion(false)}
              onBlur={() => {
                if (!DietaAlimentacion) isvalid_setDietaAlimentacion(true);
              }}
              size="small"
              style={{ marginBottom: "1rem" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>

        {/* VacunacionCompleta */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Cuenta con el esquema completo de vacunación?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Autocomplete
              options={[
                { label: "Sí", value: "1" },
                { label: "No", value: "0" },
              ]}
              getOptionLabel={(option) => option.label}
              id="VacunacionCompleta"
              disabled={desactivar}
              value={
                [
                  { label: "Sí", value: "1" },
                  { label: "No", value: "0" },
                ].find((opt) => opt.value == VacunacionCompleta) || null
              }
              onChange={(event, newValue) =>
                setVacunacionCompleta(newValue ? newValue.value : null)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  autoComplete="new-password"
                  label="Seleccione"
                  variant="outlined"
                  error={isvalid_VacunacionCompleta}
                  helperText={isvalid_VacunacionCompleta ? "Campo obligatorio *" : ""}
                  disabled={desactivar}
                  onFocus={() => {
                    isvalid_setVacunacionCompleta(false);
                    if (!DietaAlimentacion) {
                      isvalid_setDietaAlimentacion(true);
                    }
                  }}
                  onBlur={() => {
                    if (VacunacionCompleta == null) isvalid_setVacunacionCompleta(true);
                  }}
                />
              )}
              style={{ width: "100%", marginBottom: "1rem" }}
              size="small"
            />
          </Grid>
        </Grid>

        {/* FumanEnCasa y QuienFuma */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Fuman en Casa?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  id="FumanEnCasa"
                  disabled={desactivar}
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == FumanEnCasa) || null
                  }
                  onChange={(event, newValue) => {
                    setFumanEnCasa(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setQuienFuma(true);
                    } else {
                      isvalid_setQuienFuma(false);
                      setQuienFuma("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_FumanEnCasa}
                      helperText={isvalid_FumanEnCasa ? "Campo obligatorio *" : ""}
                      disabled={desactivar}
                      onFocus={() => {
                        isvalid_setFumanEnCasa(false);
                        if (!DietaAlimentacion) {
                          isvalid_setDietaAlimentacion(true);
                        }
                        if (VacunacionCompleta == null) {
                          isvalid_setVacunacionCompleta(true);
                        }
                      }}
                      onBlur={() => {
                        if (FumanEnCasa == null) isvalid_setFumanEnCasa(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    ¿Quién?
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  autoComplete="off"
                  value={QuienFuma}
                  error={isvalid_QuienFuma}
                  helperText={isvalid_QuienFuma ? "Campo obligatorio *" : ""}
                  disabled={desactivar}
                  onChange={(e) => {
                    if (FumanEnCasa != null && FumanEnCasa == "1") {
                      setQuienFuma(e.target.value);
                    }
                  }}
                  onFocus={() => {
                    isvalid_setQuienFuma(false);
                    if (!DietaAlimentacion) {
                      isvalid_setDietaAlimentacion(true);
                    }
                    if (VacunacionCompleta == null) {
                      isvalid_setVacunacionCompleta(true);
                    }
                    if (FumanEnCasa == null) {
                      isvalid_setFumanEnCasa(true);
                    }
                  }}
                  onBlur={() => {
                    if (!QuienFuma && FumanEnCasa != null && FumanEnCasa == "1") {
                      isvalid_setQuienFuma(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* IdTipoSangre y IdTipoSangreRh */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Tipo de Sangre:
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={[
                    { label: "No lo sé", value: "0" },
                    { label: "A", value: "1" },
                    { label: "B", value: "2" },
                    { label: "AB", value: "3" },
                    { label: "O", value: "4" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  id="IdTipoSangre"
                  disabled={desactivar}
                  value={
                    [
                      { label: "No lo sé", value: "0" },
                      { label: "A", value: "1" },
                      { label: "B", value: "2" },
                      { label: "AB", value: "3" },
                      { label: "O", value: "4" },
                    ].find((opt) => opt.value == IdTipoSangre) || null
                  }
                  onChange={(event, newValue) => {
                    setIdTipoSangre(newValue ? newValue.value : null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Tipo"
                      variant="outlined"
                      error={isvalid_IdTipoSangre}
                      helperText={isvalid_IdTipoSangre ? "Campo obligatorio *" : ""}
                      disabled={desactivar}
                      onFocus={() => {
                        isvalid_setIdTipoSangre(false);
                        if (!DietaAlimentacion) {
                          isvalid_setDietaAlimentacion(true);
                        }
                        if (VacunacionCompleta == null) {
                          isvalid_setVacunacionCompleta(true);
                        }
                        if (FumanEnCasa == null) {
                          isvalid_setFumanEnCasa(true);
                        }
                        if (!QuienFuma && FumanEnCasa == 1) {
                          isvalid_setQuienFuma(true);
                        }
                      }}
                      onBlur={() => {
                        if (IdTipoSangre == null) isvalid_setIdTipoSangre(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={[
                    { label: "No lo sé", value: "0" },
                    { label: "+ Positivo", value: "1" },
                    { label: "- Negativo", value: "2" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  id="IdTipoSangreRh"
                  disabled={desactivar}
                  value={
                    [
                      { label: "No lo sé", value: "0" },
                      { label: "+ Positivo", value: "1" },
                      { label: "- Negativo", value: "2" },
                    ].find((opt) => opt.value == IdTipoSangreRh) || null
                  }
                  onChange={(event, newValue) => {
                    setIdTipoSangreRh(newValue ? newValue.value : null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_IdTipoSangreRh}
                      helperText={isvalid_IdTipoSangreRh ? "Campo obligatorio *" : ""}
                      disabled={desactivar}
                      onFocus={() => {
                        isvalid_setIdTipoSangreRh(false);
                        if (!DietaAlimentacion) {
                          isvalid_setDietaAlimentacion(true);
                        }
                        if (VacunacionCompleta == null) {
                          isvalid_setVacunacionCompleta(true);
                        }
                        if (FumanEnCasa == null) {
                          isvalid_setFumanEnCasa(true);
                        }
                        if (!QuienFuma && FumanEnCasa == 1) {
                          isvalid_setQuienFuma(true);
                        }
                        if (IdTipoSangre == null) {
                          isvalid_setIdTipoSangre(true);
                        }
                      }}
                      onBlur={() => {
                        if (IdTipoSangreRh == null) isvalid_setIdTipoSangreRh(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* AsisteGuarderia */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Asiste a guardería?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Autocomplete
              options={[
                { label: "Sí", value: "1" },
                { label: "No", value: "2" },
              ]}
              getOptionLabel={(option) => option.label}
              id="AsisteGuarderia"
              disabled={desactivar}
              value={
                [
                  { label: "Sí", value: "1" },
                  { label: "No", value: "2" },
                ].find((opt) => opt.value == AsisteGuarderia) || null
              }
              onChange={(event, newValue) => setAsisteGuarderia(newValue ? newValue.value : null)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  autoComplete="new-password"
                  label="Seleccione"
                  variant="outlined"
                  error={isvalid_AsisteGuarderia}
                  helperText={isvalid_AsisteGuarderia ? "Campo obligatorio *" : ""}
                  disabled={desactivar}
                  onFocus={() => {
                    isvalid_setAsisteGuarderia(false);
                    if (!DietaAlimentacion) {
                      isvalid_setDietaAlimentacion(true);
                    }
                    if (VacunacionCompleta == null) {
                      isvalid_setVacunacionCompleta(true);
                    }
                    if (FumanEnCasa == null) {
                      isvalid_setFumanEnCasa(true);
                    }
                    if (!QuienFuma && FumanEnCasa == 1) {
                      isvalid_setQuienFuma(true);
                    }
                    if (IdTipoSangre == null) {
                      isvalid_setIdTipoSangre(true);
                    }
                    if (IdTipoSangreRh == null) {
                      isvalid_setIdTipoSangreRh(true);
                    }
                  }}
                  onBlur={() => {
                    if (AsisteGuarderia == null) isvalid_setAsisteGuarderia(true);
                  }}
                />
              )}
              style={{ width: "100%", marginBottom: "1rem" }}
              size="small"
            />
          </Grid>
        </Grid>

        {/* AlergiasCandidato */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Alergias:
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              fullWidth
              variant="outlined"
              label="Especifique"
              autoComplete="off"
              value={AlergiasCandidato}
              onChange={(e) => setAlergiasCandidato(e.target.value)}
              error={isvalid_AlergiasCandidato}
              helperText={isvalid_AlergiasCandidato ? "Campo obligatorio *" : ""}
              disabled={desactivar}
              onFocus={() => {
                isvalid_setAlergiasCandidato(false);
                if (!DietaAlimentacion) {
                  isvalid_setDietaAlimentacion(true);
                }
                if (VacunacionCompleta == null) {
                  isvalid_setVacunacionCompleta(true);
                }
                if (FumanEnCasa == null) {
                  isvalid_setFumanEnCasa(true);
                }
                if (!QuienFuma && FumanEnCasa == 1) {
                  isvalid_setQuienFuma(true);
                }
                if (IdTipoSangre == null) {
                  isvalid_setIdTipoSangre(true);
                }
                if (IdTipoSangreRh == null) {
                  isvalid_setIdTipoSangreRh(true);
                }
                if (AsisteGuarderia == null) {
                  isvalid_setAsisteGuarderia(true);
                }
              }}
              onBlur={() => {
                if (!AlergiasCandidato) isvalid_setAlergiasCandidato(true);
              }}
              size="small"
              style={{ marginBottom: "1rem" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>

        {vista == "visualizar" ? null : (
          <MDBox textAlign="right">
            <Button
              variant="contained"
              onClick={() => ValidaForm()}
              sx={{ mt: 1, mr: 1 }}
              size="small"
              color="primary"
            >
              {"Continuar"}
            </Button>
            <Button
              variant="contained"
              disabled={false}
              onClick={() => handleBack()}
              sx={{ mt: 1, mr: 1 }}
              color="secondary"
              size="small"
            >
              Volver
            </Button>
          </MDBox>
        )}
      </>
    );
  }
);
export default AntecedentesPatologicos;
